var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscoverItemIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 28.3333H25M15 23.3333H25M21.6673 5.00145C21.5081 5 21.3289 5 21.1245 5H13.667C11.8001 5 10.866 5 10.153 5.36331C9.52577 5.68289 9.0162 6.19245 8.69662 6.81966C8.33331 7.5327 8.33331 8.46682 8.33331 10.3337V29.667C8.33331 31.5338 8.33331 32.4668 8.69663 33.1798C9.0162 33.807 9.52577 34.3175 10.153 34.637C10.8653 35 11.7983 35 13.6615 35L26.3385 35C28.2017 35 29.1333 35 29.8456 34.637C30.4728 34.3175 30.9841 33.807 31.3037 33.1798C31.6666 32.4675 31.6666 31.5358 31.6666 29.6726V15.5428C31.6666 15.3384 31.6665 15.1592 31.665 15M21.6673 5.00145C22.143 5.00579 22.4428 5.02344 22.7303 5.09245C23.0704 5.17411 23.3964 5.30877 23.6946 5.49154C24.0309 5.69761 24.3197 5.98636 24.8958 6.5625L30.105 11.7716C30.6815 12.3481 30.9681 12.6356 31.1742 12.972C31.357 13.2702 31.4922 13.5954 31.5739 13.9355C31.6429 14.223 31.6607 14.5242 31.665 15M21.6673 5.00145L21.6666 9.66702C21.6666 11.5339 21.6666 12.4669 22.03 13.18C22.3495 13.8072 22.8591 14.3175 23.4863 14.637C24.1986 15 25.1317 15 26.9948 15H31.665",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverItemIcon4);
export default __webpack_public_path__ + "static/media/discoverItemIcon4.0538d9b341403d2824c4f82e5d708bc7.svg";
export { ForwardRef as ReactComponent };